import { Table, Col, Card, Space, Typography, Spin,Modal} from "antd"
import { ToolTypes, getUser,deleteFolders as deleteFoldersAPI, deleteSessions as deleteSessionsAPI,
    addFolder as addFolderAPI,moveSessions,renameFolder as renameFolderAPI,updateSession, getAllSessions,
    checkRecipientEmail, sendSessions as sendSessionsAPI, addGraphData } from "../../API";
import { Row,Text,View,Icon, Graph,Alert,Button} from "../../Components"
import { useEffect, useState, useRef } from "react"
import { useRecoilState } from "recoil"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
import { useAuthenticator } from '@aws-amplify/ui-react'
import { useMatch } from 'react-router-dom'
import { useNavigate } from "react-router-dom"
import { Metrics, Helpers, Colors,Spacing,channelColors as colors,Fonts,Images } from '../../global'
import { ReactComponent as infoIcon} from '../../Assets/SVG/Info.svg'
import { ReactComponent as closeIcon} from '../../Assets/SVG/Close.svg'
import { ReactComponent as deleteIcon} from '../../Assets/SVG/Delete.svg'
import { ReactComponent as editIcon} from '../../Assets/SVG/Edit.svg'
import { ReactComponent as exportIcon} from '../../Assets/SVG/Export.svg'
import { ReactComponent as moveFolderIcon} from '../../Assets/SVG/MoveFolder.svg'
import { ReactComponent as addFolderIcon} from '../../Assets/SVG/AddFolder.svg'
import { ReactComponent as emailIcon} from '../../Assets/SVG/Email.svg'
import {ReactComponent as clockIcon} from '../../Assets/SVG/TimeAxis_Small.svg'
import { THP_ENABLED_ARRAY,THP_CHANNEL_ICONS,THP_DEFAULT_Y_AXIS,THP_CH_ENUM,THP_ENABLED_CHANNELS } from '../../Tools/THP'
import { SDP1_ENABLED_ARRAY,SDP1_CHANNEL_ICONS,SDP1_DEFAULT_Y_AXIS,SDP1_CH_ENUM,SDP1_ENABLED_CHANNELS } from '../../Tools/SDP1'
import { ST4C_ENABLED_ARRAY,ST4C_CHANNEL_ICONS,ST4C_DEFAULT_Y_AXIS,ST4C_CH_ENUM,ST4C_ENABLED_CHANNELS } from '../../Tools/ST4C'
import { SA4C_ENABLED_ARRAY,SA4C_CHANNEL_ICONS,SA4C_DEFAULT_Y_AXIS,SA4C_CH_ENUM,SA4C_ENABLED_CHANNELS  } from '../../Tools/SA4C'
import { SSS1_ENABLED_ARRAY,SSS1_CHANNEL_ICONS,SSS1_DEFAULT_Y_AXIS,SSS1_CH_ENUM,SSS1_ENABLED_CHANNELS  } from '../../Tools/SSS1'
import { SCP1_ENABLED_ARRAY,SCP1_CHANNEL_ICONS,SCP1_DEFAULT_Y_AXIS, SCP1_CH_ENUM,SCP1_ENABLED_CHANNELS, SCP1_GRAPH_INFO  } from '../../Tools/SCP1'
import HelperService from '../../Helpers/HelperService'
import { useCookies } from 'react-cookie';
import { ResponsiveLine } from '@nivo/line'
import _ from 'lodash'

let selectedTemp = []

const styles = {
  container: {
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  symbolContainer: {
    alignItems: 'center',
    marginTop:Spacing.xm,
    marginRight:Spacing.xm,
  },
  buttons: {
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  scopeButton: {
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems:'center'
  },
  scopeButtons: {
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems:'center'
  },
  lightRowVertical: {
    borderBottomWidth:1,
    borderTopWidth:1,
    borderColor: Colors.light,
  },
  lightRow: {
    borderBottomWidth:1,
    borderColor: Colors.light,
  },
}

let defaultEn = [true,true,true,true,true,true]
let defaultEnAxis =[true,true,true,true,true,true]
let graphPropsDashboard = {enX:true,start:null,end:null,en:defaultEn,enY:defaultEnAxis,enYCount:0,currZoom:{x:0,scale:1}}
const maxAttributes = 8
let file
let fileRaw
let attributes
let xdata = []
let data = Array.from(Array(maxAttributes), () => new Array(0))
let ids = new Array(maxAttributes)
let channels = new Array(maxAttributes)
let dataRaw = Array.from(Array(maxAttributes), () => new Array(0))
let yAxisEnabledCount = 0
let newTouchPosition = -1
let lastZoomPosition = -1
let zoomStartIndex = -1
let zoomEndIndex = -1
let zoomScale = 1
let panning = false
let zooming = false
let icons
let tempUnits = Array.from(Array(maxAttributes), () => "")
let goingToGraphProps = false
let tempScopeAdjustment
let graphDataPulled = false
let tempData = []
let TOOL_CH_ENUM = []
let attributeArray
let verticalLines = []

function Folders({menu}) {
    const match = useMatch('/folders/:session')
    const currentSession = match?.params.session;
    console.log('Current Session:',currentSession)
    const { user } = useAuthenticator((context) => [context.user]);
    const [allSites, setAllSites] = useRecoilState(allSitesAtom)
    const [manifest,setManifest] = useState(allSites?.sessions && currentSession?allSites.sessions.get(currentSession)?.manifest:undefined)
    const navigate = useNavigate();
    const [sessions,setSessions] = useState(allSites.sessions?allSites.sessions:new Map())
    const [folders,setFolders] = useState(allSites?.user?.sessionFolders?allSites.user.sessionFolders:{})
    // const sessionStatus = useSelector((state) => getSessionStatus(state))
    const [selectMode,setSelectMode] = useState("false")
    const [selected,setSelected] = useState(selectedTemp)
    const [selectedCount,setSelectedCount] = useState(selectedTemp.length)
    const [lastSelected,setLastSelected] = useState(null)
    const [addFolder, setAddFolder] = useState(false)
    const [name, setName] = useState('')
    const [nameUpdated, setNameUpdated] = useState(false)
    const [addFolderLoading, setAddFolderLoading] = useState(false)
    const [moveFolder, setMoveFolder] = useState(false)
    const [moveFolderLoading, setMoveFolderLoading] = useState(false)
    const [renameFolder, setRenameFolder] = useState(false)
    const [renameFolderLoading, setRenameFolderLoading] = useState(false)
    const [renameSession, setRenameSession] = useState(false)
    const [renameSessionLoading, setRenameSessionLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(allSites.sessions?false:true)
    const [refreshing, setRefreshing] = useState(false)
    const [deleteFolders, setDeleteFolders] = useState(false)
    const [deleteSessions, setDeleteSessions] = useState(false)
    const [deleteFoldersLoading, setDeleteFoldersLoading] = useState(false)
    const [deleteSessionsLoading, setDeleteSessionsLoading] = useState(false)
    const [shareFile, setShareFile] = useState(false)
    const ref = useRef();
    const graphRef = useRef();
    const [emailError, setEmailError] = useState('')
    const [email, setEmail] = useState('')
    const [error,setError] = useState('')
    const [buttonLoading, setButtonLoading] = useState(false)
    const [sendSessions, setSendSession] = useState(false)
    const [addInitiated, setAddInitiated] = useState(false)
    const [addLoading, setAddLoading] = useState(false)
    const [verified, setVerified] = useState(false)
    const [verifyInitiated, setVerifyInitiated] = useState(false)
    const [sendSessionsStatus, setSendSessionsStatus] = useState(false)
    const userEmail = user?.attributes?.email
    const [fullscreen,setFullscreen] = useState(false);
    const [startTime, setStartTime] = useState(undefined)
    const [stopTime, setStopTime] = useState(undefined)
    const [graphData,setGraphData] = useState({"startOfData":1690394385,"data_id_createdAt":1690394385,"totalRecordCount":0,"updatedAt":HelperService.getEpoch(new Date()),"data":[], "rawData":[], "convertedData": [], "normalData":[]})
    const [startOfData,setStartOfData] = useState(graphData.startOfData)
    const [menuLoading, setMenuLoading] = useState(true);
    const [showGraphProps, setShowGraphProps] = useState(false);
    const [showExport, setShowExport] = useState(false);
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();
    const [graphWidth, setGraphWidth] = useState();
    const [graphHeight, setGraphHeight] = useState();
    const [displayData, setDisplayData] = useState([]);
    const [displayDataZoomed, setDisplayDataZoomed] = useState([]);
    const [chartUpdated, setChartUpdated] = useState(true);
    const [cookies, setCookie] = useCookies([userEmail]);
    const [xAxis, setXAxis] = useState(true);
    const [enabledAxis,setEnabledAxis] = useState(graphPropsDashboard.enY)
    const [enabled,setEnabled] = useState(graphPropsDashboard.en?graphPropsDashboard.en.map((attribute) => (attribute)):defaultEn)
    const [xdataZoomed,setXdataZoomed] = useState(xdata)
    if(currentSession != undefined && cookies[userEmail]?.currentSession != currentSession) setCookie(userEmail,{...cookies[userEmail],currentSession:currentSession})
    let enabledCount = 0
    if (enabled) {
        enabled.forEach(attribute => {
            if(attribute)  enabledCount++
        })
    }
    const CustomPoint = (props) => {
      const { currentSlice} = props;
      console.log('CustomPoint props:',props)
      // it will show the current point
      if (currentSlice && !panning && !zooming) {
        return (
          <g>
            <line
              x1={currentSlice.points[0].x}
              x2={currentSlice.points[0].x}
              y1={0}
              y2={graphHeight}
              stroke={Colors.lightGrey}
              strokeWidth="1"
              strokeDasharray={[6,3]}
            />
            {currentSlice.points.map((point)=>(
              <circle
              fill={Colors.darkGrey}
              r={2}
              strokeWidth={1}
              stroke={Colors.darkGrey}
              fillOpacity={1}
              cx={point.x}
              cy={point.y}
            />
            ))}
          </g>
        );
      }
    };
    const updateZoom = (zoom,position) => {
      console.log('Zoom:',zoom)
      console.log('Display Data:',displayDataZoomed)
      if(zoom<1 || Math.round(zoom) == 1) zoom = 1
      if(zoom>xdata.length/2) zoom = Math.floor(xdata.length/2)
      let size = Math.floor(xdata.length/zoom)
      if(zoom == 1){
        if(!_.isEqual(displayData,displayDataZoomed)){
          setChartUpdated(false)
          setDisplayDataZoomed(displayData)
          setXdataZoomed(xdata)
        }
      }else{
        zoomStartIndex = Math.max(position - (size/2),0)
        zoomEndIndex = Math.min(position + (size/2),xdata.length-1)
        if(zoomEndIndex ==  xdata.length-1){
          zoomStartIndex = Math.max(zoomEndIndex - size,0)
        }else if(zoomStartIndex ==  0){
          zoomEndIndex = Math.min(zoomStartIndex + size,xdata.length-1)
        }
        let tempDisplayData = _.cloneDeep(displayData)
        tempDisplayData.forEach((attribute)=>{
          attribute.data = attribute.data.slice(zoomStartIndex, zoomEndIndex +1)
        })
        if(!_.isEqual(tempDisplayData,displayDataZoomed)){
          setChartUpdated(false)
          setDisplayDataZoomed(tempDisplayData)
          setXdataZoomed(xdata.slice(zoomStartIndex, zoomEndIndex +1))
        }
      }
      setChartUpdated(true)
      lastZoomPosition = position
    }
    function errorCheck(){
        let errorsFound = false
        if(email==''){
            errorsFound = true
            setEmailError("Required")
        }
        if(errorsFound){
            return false
        }
        return true      
    }
    function updateEmail(email) {
        setEmail(email)
        setEmailError('')
        setVerifyInitiated(false)
        setVerified(false)
    }
    const pullFolders = async () => {
        if(user.signInUserSession.idToken.jwtToken && !_.isEmpty(allSites)){
            setMenuLoading(true)
            console.log('REPULLING Sessions')
            let dbUser = await getUser(user.signInUserSession.idToken.jwtToken).then(data => {
                console.log('getUser data:',data)
                return data
            })
            let sessions = await getAllSessions().then(data =>{
                console.log('Session Data:', data)
                return data
            })
            let updatedAllsites = {...allSites,user:dbUser,sessions:sessions,pullSessions:false}
            console.log('Updated All Sites:',updatedAllsites)
            if(currentSession && _.has(updatedAllsites,'sessions') && updatedAllsites.sessions.get(currentSession)){
              console.log('Pulling Session Data!')
                await addGraphData(updatedAllsites,setAllSites,currentSession)
            }else{
              console.log('pullFolders Updating AllSites to ',updatedAllsites)
              setAllSites(updatedAllsites)
            }
            setMenuLoading(false)
        }
    }
    
    useEffect(() => {
      if(currentSession == undefined && cookies[userEmail]?.currentSession && allSites?.sessions && allSites.sessions.get(cookies[userEmail].currentSession)) navigate(`/folders/${cookies[userEmail].currentSession}`)
    }, [userEmail,cookies]);
    
    useEffect(() => {
      if(currentSession){// && cookies[userEmail]?.currentSession != currentSession 
        zoomScale = 1
        lastZoomPosition = 1
        console.log('CURRENT SESSION CHANGED:',currentSession)
        setIsLoading(true)
        setEnabledAxis([true,true,true,true,true,true])  
      } 
    }, [currentSession]);
    useEffect(() => {
        const observer = new ResizeObserver(entries  => {
            setHeight(entries[0].contentRect.height * 0.7)
        })
        if(ref.current){
          observer.observe(ref.current)
        }
        return () => ref.current && observer.unobserve(ref.current)
      }, [ref.current])
    useEffect(() => {
        const observer = new ResizeObserver(entries  => {
            setGraphHeight(entries[0].contentRect.height)
            setGraphWidth(entries[0].contentRect.width)
        })
        if(graphRef.current){
            observer.observe(graphRef.current)
        }
        return () => graphRef.current && observer.unobserve(graphRef.current)
    }, [graphRef.current])
    useEffect(()=>{
      console.log('fullScreen Folders Updating AllSites to ',{...allSites,fullscreen:fullscreen})
        if(!_.isEqual({...allSites,fullscreen:fullscreen},allSites)) setAllSites({...allSites,fullscreen:fullscreen})
      },[fullscreen])
    useEffect(()=>{
        setChartUpdated(false)
        setStartTime(displayDataZoomed[0]?.data!=undefined && displayDataZoomed[0]?.data.length>0 && displayDataZoomed[0]?.data[0]?.x!=undefined?displayDataZoomed[0]['data'][0]['x']:undefined)
        setStopTime(displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length-1]!=undefined?displayDataZoomed[0]['data'][displayDataZoomed[0]?.data.length-1]['x']:undefined)
        setChartUpdated(true)
      },[displayDataZoomed])
    useEffect(()=>{
        setChartUpdated(false)
      },[user,currentSession,enabled,enabledAxis])
    useEffect(()=>{
        setChartUpdated(false)
        console.log('Updating zoom: ',zoomScale,lastZoomPosition)
        updateZoom(zoomScale,lastZoomPosition)
      },[displayData])
    useEffect(() => {
        if(deleteFoldersLoading){
          try {
            deleteFoldersAPI(selected).then((result)=>{
                if(result == true){
                    pullFolders()
                }
                setDeleteFoldersLoading(false)
            })
          } catch (error) {
            console.log("DELETE Folder ERROR:", error)
          }
        }else{
          clearSelection()
          setDeleteFolders(false)
        }
      }, [deleteFoldersLoading]);
      useEffect(() => {
        if(deleteSessionsLoading){
          try {
            deleteSessionsAPI(selected).then((result)=>{
                if(result == true){
                    pullFolders()
                    let tempAllSites = _.cloneDeep(allSites)
                    selected.forEach(id => {
                        tempAllSites['sessions'].delete(id)
                    })
                    console.log('deleteSessionsLoading Updating AllSites to ',tempAllSites)
                    setAllSites(tempAllSites)
                }
                setDeleteSessionsLoading(false)
            })
          } catch (error) {
            console.log("DELETE Sessions ERROR:", error)
          }
        }else{
          clearSelection()
          setDeleteSessions(false)
        }
      }, [deleteSessionsLoading]);
      //1
      useEffect(() => {
        if(addFolderLoading){
          try {
            if(_.has(folders,name)){
              let tempName = _.cloneDeep(name)
              let i = 1
              tempName = tempName + " (" + i.toFixed(0) + ")"
              while(_.has(folders,tempName)){
                tempName = tempName.split('')
                tempName[tempName.length - 2] = (++i).toFixed(0)
                tempName = tempName.join('')
              }
              addFolderAPI(tempName).then((result)=>{
                if(result == true){
                    //Just add new folder TODO
                    pullFolders()
                }
                setAddFolderLoading(false)
            })
            }else{
              addFolderAPI(name).then((result)=>{
                if(result == true){
                    //Just add new folder TODO
                    pullFolders()
                }
                setAddFolderLoading(false)
            })
            }
          } catch (error) {
            console.log("ADD Folder ERROR:", error)
          }
        }else{
          clearSelection()
          setAddFolder(false)
        }
      }, [addFolderLoading]);
      //2
      useEffect(() => {
        if(moveFolderLoading){
          try {
            let sessionsObject = []
            selected.forEach(session => {
              sessionsObject.push({"session_id":session,"target":name})
            })
            moveSessions(sessionsObject).then((result)=>{
                if(result == true){
                    pullFolders()
                }
                setMoveFolderLoading(false)
            })
          } catch (error) {
            console.log("MOVE FOLDER ERROR:", error)
          }
        }else{
          clearSelection()
          setMoveFolder(false)
        }
      }, [moveFolderLoading]);
      //3
      useEffect(() => {
        if(renameFolderLoading){
          try {
            renameFolderAPI(selected[0],name).then((result)=>{
                if(result == true){
                    pullFolders()
                }
                setRenameFolderLoading(false)
            })
          } catch (error) {
            console.log("RENAME FOLDER ERROR:", error)
          }
        }else{
          clearSelection()
          setRenameFolder(false)
        }
      }, [renameFolderLoading]);
      useEffect(() => {
        if(renameSessionLoading){
          try {
            if(selected[0]) updateSession(selected[0],{settings:{name:name}}).then((result)=>{
                console.log('Rename Result:',result)
                if(result == true){
                    //TODO
                    pullFolders()
                    //updateSessionData
                    //call(addGraphData, sessionID)
                }
                setRenameSessionLoading(false)
            })
          } catch (error) {
            console.log("RENAME SESSION ERROR:", error)
          }
        }else{
          clearSelection()
          setRenameSession(false)
        }
      }, [renameSessionLoading]);
      useEffect(() => {
        //Rerender
        setNameUpdated(false)
      }, [name]);
      useEffect(() => {
        if(!_.isEmpty(allSites)){
            console.log('Folders - allSites not empty:',allSites)
            let pullingFolders = false
            if(!_.isEqual(allSites?.user?.sessionFolders,folders) || folders == undefined || !_.isEqual(allSites?.sessions,sessions) || sessions == undefined){
                console.log('FOLDERS OR SESSIONS OUT OF SYNC')
                if(!_.isEqual(allSites?.user?.sessionFolders,folders)) console.log("folders not equal")
                if(folders == undefined)console.log("folders undefined")
                if(!_.isEqual(allSites?.sessions,sessions)){
                    console.log("sessions not equal")
                    console.log(allSites.sessions)
                    console.log(sessions)
                }
                if(sessions == undefined)console.log("sessions undefined")
                let foldersSet = false
                let sessionsSet = false
                if(allSites?.user?.sessionFolders){
                    setFolders(allSites.user.sessionFolders)
                    foldersSet = true
                }
                if(allSites?.sessions){
                    setSessions(allSites.sessions)
                    sessionsSet = true
                }
                if(foldersSet && sessionsSet){
                  setMenuLoading(false) 
                }else{
                    pullingFolders = true
                    pullFolders()
                }
            }
            if(currentSession){
                if(_.has(allSites,'sessionGraphData') && allSites.sessionGraphData.get(currentSession) == undefined){
                    if(!pullingFolders) pullFolders()
                }else if(!_.has(allSites,'sessionGraphData')){
                    if(!pullingFolders) pullFolders()
                }else if(_.has(allSites,'pullSessions') && allSites.pullSessions == true){
                  if(!pullingFolders) pullFolders()
                }
            }else if(_.has(allSites,'pullSessions') && allSites.pullSessions == true){
              if(!pullingFolders) pullFolders()
          }
        }else{
            console.log('Folders - allSites empty:',allSites)
        }
    }, [allSites,currentSession]);
    useEffect(() => {
        const handleSend = async ()=>{
            if(addLoading){
                try {
                  let tempStatus
                  if(currentSession){
                    tempStatus = await sendSessionsAPI([currentSession], email).then((result)=> result)
                  }else{
                    tempStatus = await sendSessionsAPI(selected, email).then((result)=> result)
                  }
                  if(tempStatus == true){
                      setSendSessionsStatus('ok')
                  }else{
                      setSendSessionsStatus(tempStatus.errors)
                  }
                  setAddLoading(false)
                  setAddInitiated(false)
                  setSendSession(true)
                } catch (error) {
                console.log("sendSessions ERROR:", error)
                }
            }
        }
        handleSend()
        
    }, [addLoading,addInitiated]);
    const addSelected = (id,type) => {
        if(_.isEmpty(selectedTemp)){
          setSelectMode(type)
        }
        selectedTemp.push(id)
        setSelected(selectedTemp)
        setSelectedCount(selectedTemp.length)
        
        console.log("Selected:", selectedTemp)
    }
    const removeSelected = (id) => {
        let index = selectedTemp.indexOf(id)
        selectedTemp.splice(index,1)
        if(_.isEmpty(selectedTemp)){
          setSelectMode("false")
        }
        setSelected(selectedTemp)
        setSelectedCount(selectedTemp.length)
        console.log("Selected:", selectedTemp)
    }
    
    const clearSelection = () =>{
        selectedTemp = []
        setSelected(selectedTemp)
        setSelectedCount(selectedTemp.length)
        setSelectMode("false")
    }
    useEffect(() => {
        console.log('Has sessionGraphData:',_.has(allSites,'sessionGraphData'))
        console.log('Has currentSession:',currentSession)
        if(_.has(allSites,'sessionGraphData') && currentSession && allSites.sessionGraphData.get(currentSession)){
            setIsLoading(true);
            console.log('Setting Display Data!!:',(allSites.sessionGraphData.get(currentSession)).normalData)
            let sessionData = allSites.sessionGraphData.get(currentSession)
            let dataRawTemp = Array.from(Array(maxAttributes), () => new Array(0))
            file = sessionData.normalData//.data
            fileRaw = sessionData.convertedData
            attributes = sessionData.attributes
            attributeArray = attributes
            xdata.length = 0
            data.forEach((attribute) => {
            attribute.length = 0
            })
            yAxisEnabledCount = 0
            channels.forEach((channel,index) => {
                channels[index] = undefined
                ids[index] = undefined
            })
            let manifest = allSites.sessions.get(currentSession).manifest[allSites.sessions.get(currentSession).target.mac]
            console.log('Manifest:',manifest)
            if(!ToolTypes.THP.localeCompare(manifest.toolType)){
                TOOL_CH_ENUM = THP_CH_ENUM
                defaultEn = THP_ENABLED_ARRAY(manifest,allSites.sessions.get(currentSession).target.channels)
                defaultEnAxis = THP_DEFAULT_Y_AXIS(manifest.settings.channels)
                icons = THP_CHANNEL_ICONS 
              }else if(!ToolTypes.SDP.localeCompare(manifest.toolType)){
                TOOL_CH_ENUM = SDP1_CH_ENUM
                defaultEn = SDP1_ENABLED_ARRAY(manifest,allSites.sessions.get(currentSession).target.channels)
                defaultEnAxis = SDP1_DEFAULT_Y_AXIS(manifest.settings.channels)
                icons = SDP1_CHANNEL_ICONS 
              }else if(!ToolTypes.THERMO_4_CH.localeCompare(manifest.toolType)){
                TOOL_CH_ENUM = ST4C_CH_ENUM
                defaultEn = ST4C_ENABLED_ARRAY(manifest,allSites.sessions.get(currentSession).target.channels)
                defaultEnAxis = ST4C_DEFAULT_Y_AXIS(manifest.settings.channels)
                icons = ST4C_CHANNEL_ICONS 
              }else if(!ToolTypes.ANALOG_4_CH.localeCompare(manifest.toolType)){
                TOOL_CH_ENUM = SA4C_CH_ENUM
                defaultEn = SA4C_ENABLED_ARRAY(manifest,allSites.sessions.get(currentSession).target.channels)
                defaultEnAxis = SA4C_DEFAULT_Y_AXIS(manifest.settings.channels)
                icons = SA4C_CHANNEL_ICONS 
              }else if(!ToolTypes.SWIM.localeCompare(manifest.toolType)){
                TOOL_CH_ENUM = SSS1_CH_ENUM
                defaultEn = SSS1_ENABLED_ARRAY(manifest,allSites.sessions.get(currentSession).target.channels)
                defaultEnAxis = SSS1_DEFAULT_Y_AXIS
                icons = SSS1_CHANNEL_ICONS 
              }else if(!ToolTypes.CHEM.localeCompare(manifest.toolType)){
                TOOL_CH_ENUM = SCP1_CH_ENUM
                defaultEn = SCP1_ENABLED_ARRAY(manifest,allSites.sessions.get(currentSession).target.channels)
                defaultEnAxis = SCP1_DEFAULT_Y_AXIS(manifest.settings)
                icons = SCP1_CHANNEL_ICONS(manifest)
            }
            if(_.isEqual(enabledAxis,[true,true,true,true,true,true])) setEnabledAxis(defaultEnAxis)  
            enabledAxis.forEach((axis,index) => {
            if(_.has(axis,'enabled') && axis.enabled && axis.channels.some((channel)=>enabled[channel])) yAxisEnabledCount++
            })
            // setEnalbledYAxisCount(yAxisEnabledCount)
            const tsIdx = _.indexOf(attributes,"ts")
            if(!ToolTypes.THP.localeCompare(manifest.toolType)){//STHP
                const tempIdx = _.indexOf(attributes,"sthp_temp")
                const humidIdx = _.indexOf(attributes,"sthp_humid")
                const presIdx = _.indexOf(attributes,"sthp_pres")
                const heatIdx = _.indexOf(attributes,"sthp_heatIndex")
                const dewIdx = _.indexOf(attributes,"sthp_dewPoint")
                let date
                file.forEach((item, index) => {
                    xdata[index] = item[tsIdx]
                    date = new Date((xdata[index]*1000))
                    if(tempIdx!=-1){
                        ids[0] = attributes[tempIdx]
                        channels[0] = manifest.settings.channels.sthp_temp.name
                        data[0][index] = {x:date,y:item[tempIdx]}
                        tempUnits[0] = manifest.settings.channels.sthp_temp.unit
                    } 
                    if(humidIdx!=-1){
                        ids[1] = attributes[humidIdx]
                        channels[1] = manifest.settings.channels.sthp_humid.name
                        data[1][index] = {x:date,y:item[humidIdx]}
                        tempUnits[1] = manifest.settings.channels.sthp_humid.unit
                    } 
                    if(presIdx!=-1){
                        ids[2] = attributes[presIdx]
                        channels[2] = manifest.settings.channels.sthp_pres.name
                        data[2][index] = {x:date,y:item[presIdx]}
                        tempUnits[2] = manifest.settings.channels.sthp_pres.unit
                    }
                    if(heatIdx!=-1){
                        ids[3] = attributes[heatIdx]
                        channels[3] = manifest.settings.channels.sthp_heatIndex.name
                        data[3][index] = {x:date,y:item[heatIdx]}
                        tempUnits[3] = manifest.settings.channels.sthp_heatIndex.unit
                    } 
                    if(dewIdx!=-1){
                        ids[4] = attributes[dewIdx]
                        channels[4] = manifest.settings.channels.sthp_dewPoint.name
                        data[4][index] = {x:date,y:item[dewIdx]}
                        tempUnits[4] = manifest.settings.channels.sthp_dewPoint.unit
                    }
                })
                fileRaw.forEach((item, index) => {
                    if(tempIdx!=-1) dataRawTemp[0][index] = {x:date,y:item[tempIdx]}
                    if(humidIdx!=-1) dataRawTemp[1][index] = {x:date,y:item[humidIdx]}
                    if(presIdx!=-1) dataRawTemp[2][index] = {x:date,y:item[presIdx]}
                    if(heatIdx!=-1) dataRawTemp[3][index] = {x:date,y:item[heatIdx]}
                    if(dewIdx!=-1) dataRawTemp[4][index] = {x:date,y:item[dewIdx]}
                })
            }else if(!ToolTypes.SDP.localeCompare(manifest.toolType)){//SDP1
                const tempIdx = _.indexOf(attributes,"sdp1_temp1")
                const humidIdx = _.indexOf(attributes,"sdp1_humid1")
                const presIdx = _.indexOf(attributes,"sdp1_pres1")
                const temp2Idx = _.indexOf(attributes,"sdp1_temp2")
                const humid2Idx = _.indexOf(attributes,"sdp1_humid2")
                const pres2Idx = _.indexOf(attributes,"sdp1_pres2")
                let date
                file.forEach((item, index) => {
                    xdata[index] = item[tsIdx]
                    date = new Date((xdata[index]*1000))
                    if(tempIdx!=-1){
                        ids[0] = attributes[tempIdx]
                        channels[0] = manifest.settings.channels.sdp1_temp1.name
                        data[0][index] = {x:date,y:item[tempIdx]}
                        tempUnits[0] = manifest.settings.channels.sdp1_temp1.unit
                    } 
                    if(humidIdx!=-1){
                        ids[1] = attributes[humidIdx]
                        channels[1] = manifest.settings.channels.sdp1_humid1.name
                        data[1][index] = {x:date,y:item[humidIdx]}
                        tempUnits[1] = manifest.settings.channels.sdp1_humid1.unit
                    } 
                    if(presIdx!=-1){
                        ids[2] = attributes[presIdx]
                        channels[2] = manifest.settings.channels.sdp1_pres1.name
                        data[2][index] = {x:date,y:item[presIdx]}
                        tempUnits[2] = manifest.settings.channels.sdp1_pres1.unit
                    }
                    if(temp2Idx!=-1){
                        ids[3] = attributes[temp2Idx]
                        channels[3] = manifest.settings.channels.sdp1_temp2.name
                        data[3][index] = {x:date,y:item[temp2Idx]}
                        tempUnits[3] = manifest.settings.channels.sdp1_temp2.unit
                    } 
                    if(humid2Idx!=-1){
                        ids[4] = attributes[humid2Idx]
                        channels[4] = manifest.settings.channels.sdp1_humid2.name
                        data[4][index] = {x:date,y:item[humid2Idx]}
                        tempUnits[4] = manifest.settings.channels.sdp1_humid2.unit
                    } 
                    if(pres2Idx!=-1){
                        ids[5] = attributes[pres2Idx]
                        channels[5] = manifest.settings.channels.sdp1_pres2.name
                        data[5][index] = {x:date,y:item[pres2Idx]}
                        tempUnits[5] = manifest.settings.channels.sdp1_pres2.unit
                    }
                })
                fileRaw.forEach((item, index) => {
                    if(tempIdx!=-1) dataRawTemp[0][index] = {x:date,y:item[tempIdx]}
                    if(humidIdx!=-1) dataRawTemp[1][index] = {x:date,y:item[humidIdx]}
                    if(presIdx!=-1) dataRawTemp[2][index] = {x:date,y:item[presIdx]}
                    if(temp2Idx!=-1) dataRawTemp[3][index] = {x:date,y:item[temp2Idx]}
                    if(humid2Idx!=-1) dataRawTemp[4][index] = {x:date,y:item[humid2Idx]}
                    if(pres2Idx!=-1) dataRawTemp[5][index] = {x:date,y:item[pres2Idx]}
                })
            }else if(!ToolTypes.THERMO_4_CH.localeCompare(manifest.toolType)){//ST4C
                    const ch1Idx = _.indexOf(attributes,"st4c_tC1")
                    const ch2Idx = _.indexOf(attributes,"st4c_tC2")
                    const ch3Idx = _.indexOf(attributes,"st4c_tC3")
                    const ch4Idx = _.indexOf(attributes,"st4c_tC4")
                    const ambIdx = _.indexOf(attributes,"st4c_tAmb")
                    let date
                    file.forEach((item, index) => {
                        xdata[index] = item[tsIdx]
                        date = new Date((xdata[index]*1000))
                        if(ch1Idx!=-1){
                            ids[0] = attributes[ch1Idx]
                            channels[0] = manifest.settings.channels.st4c_tC1.name
                            data[0][index] = {x:date,y:item[ch1Idx]}
                            tempUnits[0] = manifest.settings.channels.st4c_tC1.unit
                        } 
                        if(ch2Idx!=-1){
                            ids[1] = attributes[ch2Idx]
                            channels[1] = manifest.settings.channels.st4c_tC2.name
                            data[1][index] = {x:date,y:item[ch2Idx]}
                            tempUnits[1] = manifest.settings.channels.st4c_tC2.unit
                        } 
                        if(ch3Idx!=-1){
                            ids[2] = attributes[ch3Idx]
                            channels[2] = manifest.settings.channels.st4c_tC3.name
                            data[2][index] = {x:date,y:item[ch3Idx]}
                            tempUnits[2] = manifest.settings.channels.st4c_tC3.unit
                        } 
                        if(ch4Idx!=-1){
                            ids[3] = attributes[ch4Idx]
                            channels[3] = manifest.settings.channels.st4c_tC4.name
                            data[3][index] = {x:date,y:item[ch4Idx]}
                            tempUnits[3] = manifest.settings.channels.st4c_tC4.unit
                        } 
                        if(ambIdx!=-1){
                            ids[4] = attributes[ambIdx]
                            channels[4] = manifest.settings.channels.st4c_tAmb.name
                            data[4][index] = {x:date,y:item[ambIdx]}
                            tempUnits[4] = manifest.settings.channels.st4c_tAmb.unit
                        } 
                    })
                    fileRaw.forEach((item, index) => {
                        if(ch1Idx!=-1) dataRawTemp[0][index] = {x:date,y:item[ch1Idx]}
                        if(ch2Idx!=-1) dataRawTemp[1][index] = {x:date,y:item[ch2Idx]}
                        if(ch3Idx!=-1) dataRawTemp[2][index] = {x:date,y:item[ch3Idx]}       
                        if(ch4Idx!=-1) dataRawTemp[3][index] = {x:date,y:item[ch4Idx]}
                        if(ambIdx!=-1) dataRawTemp[4][index] = {x:date,y:item[ambIdx]}
                    })
                }else if(!ToolTypes.ANALOG_4_CH.localeCompare(manifest.toolType)){//SA4C
                const ch1Idx = _.indexOf(attributes,"sa4c_vC1")
                const ch2Idx = _.indexOf(attributes,"sa4c_vC2")
                const ch3Idx = _.indexOf(attributes,"sa4c_vC3")
                const ch4Idx = _.indexOf(attributes,"sa4c_vC4")
                let date
                file.forEach((item, index) => {
                    xdata[index] = item[tsIdx]
                    date = new Date((xdata[index]*1000))
                    if(ch1Idx!=-1){
                        ids[0] = attributes[ch1Idx]
                        channels[0] = manifest.settings.channels.sa4c_vC1.name
                        data[0][index] = {x:date,y:item[ch1Idx]}
                        tempUnits[0] = manifest.settings.channels.sa4c_vC1.linearScalingEnable?manifest.settings.channels.sa4c_vC1.linearScalingUnit:manifest.settings.channels.sa4c_vC1.unit
                    } 
                    if(ch2Idx!=-1){
                        ids[1] = attributes[ch2Idx]
                        channels[1] = manifest.settings.channels.sa4c_vC2.name
                        data[1][index] = {x:date,y:item[ch2Idx]}
                        tempUnits[1] = manifest.settings.channels.sa4c_vC2.linearScalingEnable?manifest.settings.channels.sa4c_vC2.linearScalingUnit:manifest.settings.channels.sa4c_vC2.unit
                    } 
                    if(ch3Idx!=-1){
                        ids[2] = attributes[ch3Idx]
                        channels[2] = manifest.settings.channels.sa4c_vC3.name
                        data[2][index] = {x:date,y:item[ch3Idx]}
                        tempUnits[2] = manifest.settings.channels.sa4c_vC3.linearScalingEnable?manifest.settings.channels.sa4c_vC3.linearScalingUnit:manifest.settings.channels.sa4c_vC3.unit
                    } 
                    if(ch4Idx!=-1){
                        ids[3] = attributes[ch4Idx]
                        channels[3] = manifest.settings.channels.sa4c_vC4.name
                        data[3][index] = {x:date,y:item[ch4Idx]}
                        tempUnits[3] = manifest.settings.channels.sa4c_vC4.linearScalingEnable?manifest.settings.channels.sa4c_vC4.linearScalingUnit:manifest.settings.channels.sa4c_vC4.unit
                    } 
                })
                fileRaw.forEach((item, index) => {
                    if(ch1Idx!=-1) dataRawTemp[0][index] = {x:date,y:item[ch1Idx]}
                    if(ch2Idx!=-1) dataRawTemp[1][index] = {x:date,y:item[ch2Idx]}
                    if(ch3Idx!=-1) dataRawTemp[2][index] = {x:date,y:item[ch3Idx]}       
                    if(ch4Idx!=-1) dataRawTemp[3][index] = {x:date,y:item[ch4Idx]}
                })
            }else if(!ToolTypes.SWIM.localeCompare(manifest.toolType)){//SSS1
                const phIdx = _.indexOf(attributes,"sss1_ph")
                const orpIdx = _.indexOf(attributes,"sss1_orp")
                const saltIdx = _.indexOf(attributes,"sss1_salt")
                const tempIdx = _.indexOf(attributes,"sss1_temp")
                const ambIdx = _.indexOf(attributes,"sss1_tAmb")
                const flowIdx = _.indexOf(attributes,"sss1_flow")
                const dutyIdx = _.indexOf(attributes,"sss1_duty")
                let date
                file.forEach((item, index) => {
                    xdata[index] = item[tsIdx]
                    date = new Date((xdata[index]*1000))
                    if(phIdx!=-1){
                        ids[0] = attributes[phIdx]
                        channels[0] = manifest.settings.channels.sss1_ph.name
                        data[0][index] = {x:date,y:item[phIdx]}
                        tempUnits[0] = manifest.settings.channels.sss1_ph.unit
                    } 
                    if(orpIdx!=-1){
                        ids[1] = attributes[orpIdx]
                        channels[1] = manifest.settings.channels.sss1_orp.name
                        data[1][index] = {x:date,y:item[orpIdx]}
                        tempUnits[1] = manifest.settings.channels.sss1_orp.unit
                    } 
                    if(saltIdx!=-1){
                        ids[2] = attributes[saltIdx]
                        channels[2] = manifest.settings.channels.sss1_salt.name
                        data[2][index] = {x:date,y:item[saltIdx]}
                        tempUnits[2] = manifest.settings.channels.sss1_salt.unit
                    } 
                    if(tempIdx!=-1){
                        ids[3] = attributes[tempIdx]
                        channels[3] = manifest.settings.channels.sss1_temp.name
                        data[3][index] = {x:date,y:item[tempIdx]}
                        tempUnits[3] = manifest.settings.channels.sss1_temp.unit
                    } 
                    if(ambIdx!=-1){
                        ids[4] = attributes[ambIdx]
                        channels[4] = manifest.settings.channels.sss1_tAmb.name
                        data[4][index] = {x:date,y:item[ambIdx]}
                        tempUnits[4] = manifest.settings.channels.sss1_tAmb.unit
                    }
                    if(flowIdx!=-1){
                        ids[5] = attributes[flowIdx]
                        channels[5] = manifest.settings.channels.sss1_flow.name
                        data[5][index] = {x:date,y:item[flowIdx]}
                        tempUnits[5] = manifest.settings.channels.sss1_flow.unit
                    }
                    if(dutyIdx!=-1){
                        ids[6] = attributes[dutyIdx]
                        channels[6] = manifest.settings.channels.sss1_duty.name
                        data[6][index] = {x:date,y:item[dutyIdx]}
                        tempUnits[6] = manifest.settings.channels.sss1_duty.unit
                    }
                })
                fileRaw.forEach((item, index) => {
                    if(phIdx!=-1) dataRawTemp[0][index] = {x:date,y:item[phIdx]}
                    if(orpIdx!=-1) dataRawTemp[1][index] = {x:date,y:item[orpIdx]}
                    if(saltIdx!=-1) dataRawTemp[2][index] = {x:date,y:item[saltIdx]}       
                    if(tempIdx!=-1) dataRawTemp[3][index] = {x:date,y:item[tempIdx]}
                    if(ambIdx!=-1) dataRawTemp[4][index] = {x:date,y:item[ambIdx]}
                    if(flowIdx!=-1) dataRawTemp[5][index] = {x:date,y:item[flowIdx]}
                    if(dutyIdx!=-1) dataRawTemp[6][index] = {x:date,y:item[dutyIdx]}
                })
            }else if(!ToolTypes.CHEM.localeCompare(manifest.toolType)){//SCP1
                let graphInfo = SCP1_GRAPH_INFO(manifest,tsIdx,attributes,file,fileRaw,xdata,channels,data,tempUnits,dataRawTemp)
                channels =  graphInfo[0]
                data =  graphInfo[1]
                tempUnits =  graphInfo[2]
                dataRawTemp =  graphInfo[3]
            }
            dataRaw = dataRawTemp
            let tempDisplayData = []
            tempData = []
            ids.forEach((value,index)=>{
                if(!_.isEqual(value,undefined)){
                    tempData.push({id:ids[index],color:colors[index],data:data[index]})
                    if(enabled[index]) tempDisplayData.push({id:ids[index],color:colors[index],data:data[index]})
                }
            })
            // setUnits(tempUnits)           
            // updateZoom({scaleX:1, cx:zoomScale})
            // setTime(sessionData.updatedAt)
            console.log('New Display Data:',tempDisplayData)
            setGraphData(sessionData)
            setStartOfData(sessionData.startOfData)
            setDisplayData([...tempDisplayData])
            // setDisplayDataZoomed(tempDisplayData)
            // updateZoom(zoomScale,lastZoomPosition)
            setManifest(manifest)
            setChartUpdated(true)
            setIsLoading(false)
        }
    }, [currentSession,enabled,enabledAxis,allSites]);


    return ((isLoading || !chartUpdated) && currentSession && displayDataZoomed && !menu) || ( menuLoading && !currentSession)?<View  style={{...Helpers.fillCenter,height:'100%'}}>
    <Spin size="large" />
  </View>:currentSession && !menu?(
    <View style={{height:'calc(100vh - 80px)',overflow:'hidden'}}>
        <View style={{display:'flex',flexDirection: 'column',width:'100%',height:'100%',x:0,y:0,overflow:'hidden',position:fullscreen?'absolute':'relative'}}>
            {fullscreen?<></>:<View style={{overflow:'none'}}>
                <Row.PageTitle 
                    title={allSites.sessions?allSites.sessions.get(currentSession).settings.name:''}/>
            </View>}
            <Row.ToolGraphOptions
                navToGraphProps = {()=>{setShowGraphProps(true)}}
                navToExport = {()=>{
                    setShareFile(true)
                }}
                setFullscreen = {setFullscreen}
                fullscreen = {fullscreen}
                resetZoom = {()=>{
                  zoomScale = 1
                  updateZoom(zoomScale,1)
                }}
                zoom = {displayData[0]?.data?.length != displayDataZoomed[0]?.data?.length}
                start = {startTime}
                end = {stopTime}
            />
            <View style={{display:'flex',flexGrow:1}}>
        {console.log('Current enabledAxis:',enabledAxis)}
      <View style={{display:'flex',...Helpers.row,flex:1}}>
      {enabledAxis?enabledAxis.map((axis, index) => (
            Graph.AxisUsed(xdataZoomed.length,axis,enabled) && displayDataZoomed.reduce((accumulator, currentValue) => accumulator + currentValue.data.length, 0)>0 && graphHeight?<Graph.YAxis
            style={{ backgroundColor:axis.channels.length>1?Colors.darkGrey:colors[axis.channels[0]] }}
            // height={height}
            isLoading = {isLoading}
            axis={axis}
            toolType={manifest?manifest.toolType:''}
            maxData={graphData.maxData}
            minData={graphData.minData}
            index={index}
            attributes={graphData.attributes}
        />:<></>
        )):<></>}
        </View>
      <div ref={graphRef} style={{display:'flex',width:'100%',height:'100%'}}>
      <div style={{display:'flex',width:graphWidth,height:graphHeight,position:'absolute',...Helpers.row}}
        onWheel={(e)=>{
          console.log("Zoom Index:",newTouchPosition)
          if(e.deltaY<0){
            console.log("Zoom In")
            zooming = true
            zoomScale = Math.min(Math.floor(xdata.length/2),zoomScale*2)
            updateZoom(zoomScale,newTouchPosition)
            zooming = false
          } 
          if(e.deltaY>0){
            console.log("Zoom Out")
            zooming = true
            zoomScale = Math.max(1,zoomScale/2)
            updateZoom(zoomScale,newTouchPosition)
            zooming = false
          }
        }}
        onMouseDown={(event)=>{
          console.log('MouseDown Event:',event)
          if(!_.isEqual(displayData,displayDataZoomed)) panning = true
        }} 
        onMouseMove={(event)=>{
          if(panning){
            console.log('MouseMove Event:',event)
            let nextPosition
            if(event.movementX<0){
              console.log("Pan Left")
              nextPosition = Math.min(lastZoomPosition+1,xdata.length-1)
              updateZoom(zoomScale,nextPosition)
            } 
            if(event.movementX>0){
              console.log("Pan Right")
              nextPosition = Math.max(0,lastZoomPosition-1)
              updateZoom(zoomScale,nextPosition)
            }
          }
        }}
        onMouseLeave={(event)=>{
          console.log('MouseUp Leave:',event)
          panning = false
        }}
        onMouseUp={(event)=>{
          console.log('MouseUp Event:',event)
          panning = false
        }}>
      {console.log('displayData:',displayDataZoomed)}
      {displayDataZoomed.reduce((accumulator, currentValue) => accumulator + currentValue.data.length, 0)>1 && chartUpdated && !isLoading?
      <ResponsiveLine
      data={chartUpdated?displayDataZoomed:[]}
      margin={{ top: 10, right: 20, bottom: 10, left: 10 }}
      xScale={{
        type: 'time',
        format: 'native',
        }}
      yScale={{
          type: 'linear',
          min: 0,
          max: 1,
          stacked: false,
          reverse: false
      }}
      gridYValues={[0,1/6,2*1/6,3*1/6,4*1/6,5*1/6,1]}
      gridXValues={xAxis?verticalLines:[new Date(xdataZoomed[0]*1000),new Date(xdataZoomed[xdataZoomed.length-1]*1000)]}
      yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisLeft={null}
      axisBottom={null}
      sliceTooltip={({ slice }) => {
        console.log('slice:',slice)
        const apx = (size = 0, min=null) => {
          if(min){
            if(((graphWidth / 750) * size) > min) return min
          }
          return (graphWidth / 750) * size;
        };
        const apy = (size = 0, min=null) => {
          if(min){
            if(((graphHeight / 750) * size) > min) return min
          }
          return (graphHeight / 750) * size;
        };
        let counted = 0
        const countedIncrement = (enabled) =>{
            if(enabled) counted ++
        }
        // if (positionX < 0) {
        //     return null;
        // }

        let date = slice.points[0].data.x//new Date(xdata[positionX]*1000)
        console.log('Date:',date)
        console.log(HelperService.formatDate(date,1))
        console.log(HelperService.formatTime(date,0))
        enabledCount = 0
        slice.points.forEach(attribute => {
            if(attribute)  enabledCount++
        })
        let longestData = 0
        let currentData = ""
        let index
        let dateIndex = graphData.convertedData.findIndex((x)=> new Date(x[_.indexOf(attributeArray,"ts")]*1000).getTime() === date.getTime())
        newTouchPosition = dateIndex
        console.log('dateIndex',dateIndex)
        slice.points.forEach((attribute) => {
          index = attributeArray.findIndex((x)=> x == attribute.serieId);
          console.log('attribute.serieId:',attribute.serieId)
          console.log('attributeArray:',attributeArray)
          console.log('Index:',index)
          console.log('tempUnits:',tempUnits)
            if(_.has(attribute.data,"y") && attribute.data.y !=null && !isNaN(attribute.data.y)){
                currentData = attribute.data.y.toFixed(2)+" "+tempUnits[index-1]
                if(currentData.length>longestData) longestData = currentData.length
            }
        })
        console.log('currentData:',currentData)
        let dateString = HelperService.formatDate(date,1) + " " + HelperService.formatTime(date,0)
        let timeLength = (8*(dateString.length + 1))
        let toolTipWidth = Math.max(100,Math.floor(8*longestData),timeLength)
        let toolTipHeight = Math.max(apy(48+(enabledCount*24)),80)
        console.log('toolTipWidth:',toolTipWidth)
        
        return (
          <svg height={toolTipHeight} width={toolTipWidth}  key="tooltip">
                  <g
                    height={toolTipHeight} width={toolTipWidth}
                  >
                      <rect
                          rx={12} // borderRadius
                          ry={12} // borderRadius
                          width={toolTipWidth}
                          height={toolTipHeight}
                          stroke={Colors.light}//color
                          fill={Colors.light}//color
                      />
                      <text 
                        x={apx(10)}
                        y={((toolTipHeight)/(enabledCount+2))}
                        textAnchor='start' 
                        fill={Colors.lightGrey} 
                        fontSize={Fonts.small.fontSize} 
                        fontFamily='Inter-Regular'>
                          {HelperService.formatDate(date,1)}
                      </text>
                      <text 
                        x={toolTipWidth-10}
                        y={((toolTipHeight)/(enabledCount+2))}
                        textAnchor='end' 
                        fill={Colors.lightGrey} 
                        fontSize={Fonts.small.fontSize} 
                        fontFamily='Inter-SemiBold'>
                          {HelperService.formatTime(date,0)}
                      </text>
                      <line
                          x1={apx(0)}
                          x2={toolTipWidth}//Number(ticks.length)
                          y1={((toolTipHeight)/(enabledCount+2))+4}
                          y2={((toolTipHeight)/(enabledCount+2))+4}
                          stroke={Colors.white}
                          strokeWidth={2}
                      />
                      {console.log('convertedData:',graphData.convertedData)}
                      {ids.map((id, inx) => {
                        let i = attributeArray.findIndex((attribute)=>id == attribute)
                        let index = slice.points.findIndex((point)=>id == point.serieId)
                        console.log('attribute:',id)
                        console.log('index:',index)
                        console.log('i:',i)
                        return(
                            index>-1 && slice.points[index] && id[inx]? <><text
                              x={toolTipWidth-10}
                              y={((toolTipHeight)/(enabledCount+2))*(counted+2)+4}
                              fontSize={Fonts.small.fontSize}
                              fill={colors[inx]}
                              textAnchor='end'
                              fontFamily='Inter-Regular'>
                              {_.has(slice.points[index].data,"y") && graphData.convertedData[dateIndex][i] !=null && !isNaN(graphData.convertedData[dateIndex][i])?graphData.convertedData[dateIndex][i].toFixed(2)+" "+tempUnits[inx]:"null"}
                          </text>
                          {countedIncrement(slice.points[index])}
                          </>:<></>                            
                      )})}
                  </g>
              </svg>
        )
    }} 
      colors={(d)=>d.color}
      enablePoints={false}
      enableSlices="x"
      crosshairType="cross"
      legends={[]}
      enableCrosshair= {false}
      motionConfig="gentle"
      layers={['grid', 'markers', 'axes', 'areas', 'crosshair', 'lines', 'points',CustomPoint, 'slices', 'mesh', 'legends']}
      animate={false}
  />:
    <View  style={{...Helpers.fillCenter,height:'100%'}}>
      {isLoading || !chartUpdated?<Spin size="large" />:<Text as={"xlarge"} color={"darkGrey"}weight={"bold"} >{_.isEqual(displayDataZoomed,[]) || displayDataZoomed[0]?.data?.length == 0?'No Graph Data Available For This Scope':'Not Enough Data to Graph'}</Text>}
    </View>}
    
    </div>
    </div>
      </View>
      {xAxis && xdataZoomed.length > 1?<View style={{
                                display:'flex',
                                flexDirection: 'row',
                                alignSelf: 'stretch',
                                height:20
                            }}>
                      <View style={{...Helpers.row,width:50*yAxisEnabledCount}}>
                        {enabledAxis?enabledAxis.map((axis,index) => (
                            Graph.AxisUsed(xdataZoomed.length,axis,enabled) && xdataZoomed.length > 1 && !isLoading && displayDataZoomed.reduce((accumulator, currentValue) => accumulator + currentValue.data.length, 0)>0?<View style={{display:'flex',width:50,alignItems:'center',justifyContent:'center'}}>
                                <Text as="small" weight="bold" style={{color:axis.channels.length>1?Colors.darkGrey:colors[axis.channels[0]]}}>{tempUnits[axis.channels[0]]}</Text>
                            </View>:<></>
                        )):<></>}
                      </View>
                      {xdataZoomed.length > 1 && !isLoading && displayDataZoomed.reduce((accumulator, currentValue) => accumulator + currentValue.data.length, 0)>0?<Graph.XAxis
                        xdata={xdataZoomed}
                        isLoading = {isLoading}
                        yAxisEnabledCount={yAxisEnabledCount}
                        axisWidth={50}
                        horizontalContentInset={{ right: 20, left: 10 }}
                        width={graphWidth}
                        landscape = {true}
                        verticalLines = {verticalLines}
                        setVerticalLines={(lines)=>verticalLines = lines}
                      />:<></>}
                    </View>:<View style={{display:'flex',flexDirection: 'row',alignSelf: 'stretch',height:20}}>{enabledAxis?enabledAxis.map((axis) => (
                            Graph.AxisUsed(xdataZoomed.length,axis,enabled) && xdataZoomed.length > 1 && !isLoading && displayDataZoomed.reduce((accumulator, currentValue) => accumulator + currentValue.data.length, 0)>0?<View style={{display:'flex',width:50,alignItems:'center',justifyContent:'center'}}>
                                <Text as="small" weight="bold" style={{color:axis.channels.length>1?Colors.darkGrey:colors[axis.channels[0]]}}>{tempUnits[axis.channels[0]]}</Text>
                            </View>:<View style={{height:20}}/>
                        )):<></>}</View>}
      <View style={[styles.scopeButtons,styles.lightRowVertical,Metrics.tinyHorizontalMargin]}>
      <View style={[styles.buttons,styles.lightRow,{overflow:'auto',width:'100%'}]}>
            {tempData.map((attribute, index) => {
                console.log('Current Attribute:',attribute)
                return !_.isEmpty(attribute) && !_.isEmpty(icons) && icons[index]?
                <View
                key={'graphAtt'+index}
                style={[Helpers.row,Metrics.tinyHorizontalMargin,{cursor:'pointer',height:38,...Helpers.center}]}
                onClick={() => {
                    if(enabledCount==1 && enabled[index]){
                        //Don't allow empty graph
                    }else{
                        let newEnabled = [...enabled]
                        newEnabled[index] = !enabled[index]
                        graphDataPulled = false
                        setEnabled(_.cloneDeep(newEnabled))
                        console.log('newEnabled:',newEnabled)
                        // updateToolSettings(tool,{graphPropsDashboard:{}})
                    }            
                }}>
                    <Icon svg={icons[index]} size="xs" color={enabled[index] ? colors[index] : Colors.vlightGrey}/>
                    <View style={{width:Spacing.sm}}></View>
                    <Text color={enabled[index] ?"darkGrey":"vlightGrey"} style={{whiteSpace:'nowrap'}}>{channels[index]}</Text>
                </View>:<></>
            })} 
        </View>
        </View>
        </View>
        <Modal title='Graph Properties' bodyStyle={{overflowY: 'auto',height:fullscreen?graphHeight*0.8:graphHeight}} open={showGraphProps} footer={null} onCancel={()=>setShowGraphProps(false)} onOk={()=>setShowGraphProps(false)}>
        <Row.Section title={'X Axis'}></Row.Section>
        <Row.Toggle //Enable/Disable
            title="Display Time Axis"
            icon={clockIcon}
            value={xAxis}
            onValueChange={(value) => {
                setXAxis(value)
            }}
        />
        <Row.Section title={'Y Axis'}></Row.Section>
        {console.log('graphData:',graphData)}
        {console.log('MinData:',graphData.minData,'MaxData:',graphData.maxData)}
        {enabledAxis?enabledAxis.map((axis, index) => (
          axis!=undefined && _.has(axis,'channels')?
          <Row.YAxis //Enable/Disable
            // enabled={axis.enabled}
            name={axis.name}
            channels={axis.channels}
            icons={axis.channels.map((channel) => (icons[channel]))}
            // auto={axis.auto}
            min={axis.auto && graphData.minData?Math.min(...axis.channels.reduce((prev,cur)=>prev.concat(graphData.minData[_.findIndex(attributes,function(o) { return o == TOOL_CH_ENUM[cur]})]),[])):axis.min}
            max={axis.auto && graphData.maxData?Math.max(...axis.channels.reduce((prev,cur)=>prev.concat(graphData.maxData[_.findIndex(attributes,function(o) { return o == TOOL_CH_ENUM[cur]})]),[])):axis.max}
            axisIndex={index}
            enabledAxis={enabledAxis}
            setEnabledAxis={setEnabledAxis}
            unit={manifest && manifest.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]?.linearScalingEnable?manifest.settings.channels[TOOL_CH_ENUM[axis.channels[0]]].linearScalingUnit:
                manifest?manifest.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]?.unit:''}
          />:<></>
        )):<></>}
        </Modal>
        <Modal title='Send File' bodyStyle={{overflowY: 'auto',height:fullscreen?graphHeight*0.8:graphHeight}} open={shareFile} footer={null} 
        onCancel={()=>{
            setShareFile(false)
            setSendSession(false)
        }} onOk={()=>{
            setShareFile(false)
            setSendSession(false)
            }}>
        <Text color="darkGrey" as="large">{'Enter email to share Stratus File'}</Text>
          <Row.AuthInput label="Email Address" icon={emailIcon} value={email} setValue={updateEmail} error={emailError} setError={setEmailError}/>
          <Text color="error" weight="light">{error}</Text>
          <Text color="error" weight="light">{emailError}</Text>
          <Button
              style={Metrics.smallTopMargin}
              isLoading = {buttonLoading}
              disabled = {verified}
              text="Verify"
              variant="primary-transparent"
              onPress={async () => {
                  if(userEmail != email){
                      await setError('')
                      await setButtonLoading(true)
                      if(await errorCheck()){
                          try {
                              let resp = await checkRecipientEmail(user.signInUserSession.idToken.jwtToken,email)
                              setVerified(resp)
                          } catch (error) {
                              console.log(error)
                              switch(error.code){
                                  default:
                                      await setError(error.message)
                                  break
                              }
                          }
                          await setVerifyInitiated(true)
                      }         
                      await setButtonLoading(false)  
                  }else{
                      setEmailError("Can't share with yourself")
                  }
              }}
          />
          {verified?<Text color="darkGrey" as="large">{'Email Successfully Verified'}</Text>:
          verifyInitiated?<Text color="darkGrey" as="large">{'The email entered does not have a Stratus account associated with it'}</Text>:
          <></>}
          <Button
              style={Metrics.smallTopMargin}
              isLoading = {addLoading}
              disabled = {!verified}
              text="Send File"
              variant="primary"
              onPress={() => {
                  setError('')
                  setSendSessionsStatus('')
                  setAddLoading(true)
                  setAddInitiated(true)      
              }}
          />              
        </Modal>
        <Alert 
          visible={sendSessions } 
          setVisible={setSendSession} 
          oneButton={true} 
          title={sendSessionsStatus == 'ok'?"Stratus File Sent":"Share Error" }
          text={sendSessionsStatus == 'ok'?"Stratus File has been sent to "+email:(sendSessionsStatus)} 
          onPress={async ()=>{
              setSendSession(false)
              setShareFile(false)
              }}
        />
    </View>):menu?(
        <View style={{height:'calc(100vh - 80px)',overflow:'clip'}}>
            <View style={{display:'flex',flexDirection: 'column',width:'100%',height:'100%',overflow:'auto'}}>
            <div ref={ref} style={{display:'flex',flexDirection: 'column',width:'100%',height:'100%'}}>
                <View style={{overflow:'none'}}>
                    <Row.Section title={'Folders'}></Row.Section>
                    <Row.PageTitle
                        minHeight={true}
                        title={' '}//{selectedCount?(selectedCount+" Selected"):"Folders"}
                        left={selectedCount?{ icon: closeIcon, onPress: () => {
                            clearSelection()
                          } }:null}
                        right={selectedCount?{ icon: editIcon, disabled:selectedCount==1?false:true, onPress: () => {
                            if(selectMode =="folder"){
                              setName(selected[0])
                              setNameUpdated(true)
                              setRenameFolder(true)
                            }else if(selectMode =="session"){
                              setName(sessions.get(selected[0]).settings.name)
                              setNameUpdated(true)
                              setRenameSession(true)
                            }
                          }}:{ icon: addFolderIcon, onPress: () => {
                            setName('New Folder')
                            setNameUpdated(true)
                            setAddFolder(true)
                        }}}
                        right2={selectedCount?{ icon: exportIcon, disabled:selectMode =="folder", onPress: () => {
                            if(selectMode =="session"){
                                setShareFile(true)
                            //   NavigationService.navigate('Modal',
                            //       {screen: 'ShareSession',params: {
                            //           sessionIDs:selected}})
                            }
                            
                        }}:null}
                        right3={selectedCount?{ icon: moveFolderIcon, disabled:selectMode =="session"?false:true, onPress: () => {
                            if(selectMode =="session"){
                              setMoveFolder(true)
                            }else{
                              console.log("Disabled")
                            }
                        }}:null}
                        right4={selectedCount?{ icon: deleteIcon, onPress: () => {
                            if(selectMode =="folder"){
                              setDeleteFolders(true)
                            }else{
                              setDeleteSessions(true)
                            }
                        }}:null} />
                </View>
                <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto'}}>
                {Object.keys(folders).length>1 || (_.has(folders,"/root") && folders["/root"].length>0)  ? (
    <View>
      {Object.keys(folders).map(key => (
        key!="/root"?
        <Row.Folder
          key = {key}
          title = {key}
          lastSelected = {lastSelected}
          selected = {selected}
          folders = {folders}
          sessions = {!_.isEmpty(folders[key])?
            <View>
            {folders[key].map((item, index) => (
              <Row.Session
                  key = {item}
                  title = {_.has(sessions.get(item),"settings")?sessions.get(item).settings.name:""}
                  getToolName = { () => {
                    let session = sessions.get(item)
                    let mac = _.has(session,"target")?session.target.mac:undefined
                    let manifest = mac!=undefined?_.get(session.manifest,mac):undefined
                    return manifest!=undefined?manifest.settings.toolName:""
                    }
                  }
                  sessionID = {item}
                  addSelected = {addSelected}
                  removeSelected = {removeSelected}
                  selectMode = {selectMode}
                  inFolder = {true}
                  sessions={sessions}
                  lastSelected={lastSelected}
                  selected={selected}
                  currentSession = {currentSession}
                  onPress = {()=>{
                    navigate(`/folders/${item}`)
                    }}
              />
              ))}
            </View>:<></>}
            addSelected = {addSelected}
            removeSelected = {removeSelected}
            selectMode = {selectMode}
        />:<></>
        ))}
      {_.has(folders,"/root")?folders["/root"].map((item, index) => (
        <Row.Session
          key = {item}
          title = {_.has(sessions.get(item),"settings")?sessions.get(item).settings.name:""}
          sessionID = {item}
          getToolName = { () => {
            let session = sessions.get(item)
            let mac = _.has(session,"target")?session.target.mac:undefined
            let manifest = mac!=undefined?_.get(session.manifest,mac):undefined
            return manifest!=undefined?manifest.settings.toolName:""
            }
          }
          addSelected = {addSelected}
          removeSelected = {removeSelected}
          selectMode = {selectMode}
          inFolder = {false}
          sessions={sessions}
          lastSelected={lastSelected}
          selected={selected}
          currentSession = {currentSession}
          onPress = {()=>{
            navigate(`/folders/${item}`)
          }}
        />
      )):<></>}
    </View>
):menuLoading && !refreshing?<View style={{...Helpers.colCross,flex:1,height:'100%'}}><Spin/></View>:(
  <View style={{...Helpers.colCross, ...Metrics.largeTopMargin,flex:1,height:'100%'}}>
    <img style={{height:180,width:180}} src={Images.noSessions} resizeMode={'contain'} /> 
    <Text
      color="primary"
      style={{ ...Helpers.textCenter, ...Fonts.normal, ...Metrics.smallVerticalPadding }}
    >
      {'Saved Stratus Files will appear here.'}
    </Text>
  </View>
)}
<Modal title='Send File' bodyStyle={{overflowY: 'auto',height:fullscreen?height*0.8:height}} open={shareFile} footer={null} 
onCancel={()=>{
    setShareFile(false)
    setSendSession(false)
}} onOk={()=>{
    setShareFile(false)
    setSendSession(false)
    }}>
<Text color="darkGrey" as="large">{'Enter email to share Stratus File'}</Text>
                <Row.AuthInput label="Email Address" icon={emailIcon} value={email} setValue={updateEmail} error={emailError} setError={setEmailError}/>
                <Text color="error" weight="light">{error}</Text>
                <Text color="error" weight="light">{emailError}</Text>
                <Button
                    style={Metrics.smallTopMargin}
                    isLoading = {buttonLoading}
                    disabled = {verified}
                    text="Verify"
                    variant="primary-transparent"
                    onPress={async () => {
                        if(userEmail != email){
                            await setError('')
                            await setButtonLoading(true)
                            if(await errorCheck()){
                                try {
                                    let resp = await checkRecipientEmail(user.signInUserSession.idToken.jwtToken,email)
                                    setVerified(resp)
                                } catch (error) {
                                    console.log(error)
                                    switch(error.code){
                                        default:
                                            await setError(error.message)
                                        break
                                    }
                                }
                                await setVerifyInitiated(true)
                            }         
                            await setButtonLoading(false)  
                        }else{
                            setEmailError("Can't share with yourself")
                        }
                    }}
                />
                {verified?<Text color="darkGrey" as="large">{'Email Successfully Verified'}</Text>:
                verifyInitiated?<Text color="darkGrey" as="large">{'The email entered does not have a Stratus account associated with it'}</Text>:
                <></>}
                <Button
                    style={Metrics.smallTopMargin}
                    isLoading = {addLoading}
                    disabled = {!verified}
                    text="Send File"
                    variant="primary"
                    onPress={() => {
                        setError('')
                        setSendSessionsStatus('')
                        setAddLoading(true)
                        setAddInitiated(true)      
                    }}
                />
                
</Modal>
    <Alert 
        visible={sendSessions } 
        setVisible={setSendSession} 
        oneButton={true} 
        title={sendSessionsStatus == 'ok'?"Stratus File Sent":"Share Error" }
        text={sendSessionsStatus == 'ok'?"Stratus File has been sent to "+email:(sendSessionsStatus)} 
        onPress={async ()=>{
            setSendSession(false)
            setShareFile(false)
            }}
    />
  <Alert 
    visible={addFolder} 
    setVisible={setAddFolder} 
    defaultValue = {name}
    valueUpdated = {nameUpdated}
    title="Add Folder" 
    textInput="Name" 
    loading = {addFolderLoading}
    onPress={async (name)=>{
      setName(name)
      setAddFolderLoading(true)
    }}
  />
  <Alert 
    visible={moveFolder} 
    setVisible={setMoveFolder} 
    title="Move To" 
    list = {Object.keys(folders)} 
    onPress={async (folder)=>{
      setName(folder)
      setMoveFolderLoading(true)
    }}
    loading = {moveFolderLoading}
  />
  <Alert 
    visible={renameFolder} 
    setVisible={setRenameFolder}
    defaultValue = {name}
    valueUpdated = {nameUpdated}
    title="Folder Name" 
    textInput="Name" 
    onPress={async (name)=>{
      setName(name)
      setRenameFolderLoading(true)
    }}
    loading = {renameFolderLoading}
  />
  <Alert 
    visible={renameSession} 
    setVisible={setRenameSession}
    defaultValue = {name}
    valueUpdated = {nameUpdated}
    title="File Name" 
    textInput="Name" 
    onPress={async (name)=>{
      console.log("SESSIONS NEW NAME:",name)
      setName(name)
      setRenameSessionLoading(true)
    }}
    loading = {renameSessionLoading}
  />
  <Alert 
    visible={deleteSessions} 
    setVisible={setDeleteSessions} 
    title={selectedCount>1?"Delete Files":"Delete File"} 
    text={selectedCount>1?"Are you sure you want to delete these files?":"Are you sure you want to delete this file?"} 
    loading = {deleteSessionsLoading}
    onPress={async ()=>{
      if(selected.findIndex((sesh)=>sesh == currentSession) > -1){
        setCookie(userEmail,{...cookies[userEmail],currentSession:null})
        navigate(`/folders`)
      }
      setDeleteSessionsLoading(true)
    }}
  />
  <Alert 
    visible={deleteFolders} 
    setVisible={setDeleteFolders} 
    title={selectedCount>1?"Delete Folders":"Delete Folder"} 
    text={selectedCount>1?"Are you sure you want to delete these folders?":"Are you sure you want to delete this folder?"} 
    loading = {deleteFoldersLoading}
    onPress={async ()=>{
      console.log('selected:',selected)
      console.log('currentSession:',currentSession)
      console.log('folders:',folders)
      selected.forEach(folder => {
        if(folders[folder].findIndex((sesh)=>sesh == currentSession) > -1){
          setCookie(userEmail,{...cookies[userEmail],currentSession:null})
          navigate(`/folders`)
        }
      });
      setDeleteFoldersLoading(true)
    }}>
      <View style={[Helpers.row,{marginTop:Spacing.sm}]} gutter="none">
        <View style={styles.symbolContainer}>
          <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
        </View>
        <View style={styles.container}>
          <Text color='lightGrey' as='small'>Deleting a folder will delete the Stratus files within the folder.</Text>
        </View>
      </View>
    </Alert>
                </View>
                </div>
            </View>
        </View>
    ):<></>
}

export default Folders;